<template>
  <div id="review-result-dialog">
    <ipub-model :title="'Review Result Details'"
                width="1000px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="mar-b-20">
        <ipub-row :gutter="12">
          <ipub-col :span="6">
            <div>
              <span class="ipub-p2 fw-bd">Review Status</span>
              <ipub-select v-model="params.stateList"
                           v-if="mac"
                           style="width: calc(100% - 120px)"
                           @change="getList()"
                           class="mar-l-10"
                           placeholder="All">
                <ipub-select-option v-for="(value, key) in ACADEMIC_STATUS"
                                    :key="key"
                                    :value="key">
                  {{ value }}
                </ipub-select-option>
              </ipub-select>
              <ipub-select v-model="params.stateList"
                           v-else
                           style="width: calc(100% - 120px)"
                           @change="getList()"
                           class="mar-l-10"
                           placeholder="All">
                <ipub-select-option v-for="(value, key) in  REVIEWER_STATUS"
                                    :key="key"
                                    :value="key">
                  {{ value }}
                </ipub-select-option>
              </ipub-select>
            </div>
          </ipub-col>
          <ipub-col :span="6">
            <span class="ipub-p2 fw-bd"
                  style="margin-right:16px">Invite Time</span>
            <div class="ipub-p2 ipub-tab-list">
              <a :class="['ipub-tab-list--tab', isActive===key?'active':'']"
                 @click="searchList(key)"
                 v-for="(value,key) in timeList"
                 :key="key">
                {{value}}
              </a>
            </div>
          </ipub-col>
        </ipub-row>

      </div>
      <!-- <div class="ipub-line-block ipub-border mar-b-4"
           v-for="item in reviewResult"
           :key="item.id">
        <ipub-row :gutter="20">
          <ipub-col :span="1.5">{{item.code}}</ipub-col>
          <ipub-col :span="3">Invite Time: {{$moment(item.invitedTime).format('YYYY | MM | DD HH:mm')}}</ipub-col>
          <ipub-col :span="3">Review Status:
            <font :class="['ipub-reviewer-status-item--'+item.status]"
                  v-if="mac">{{ACADEMIC_STATUS[item.status]}}</font>
            <font :class="['ipub-reviewer-status-item--'+item.status]"
                  v-else>{{REVIEWER_STATUS[item.status]}}</font>
          </ipub-col>
          <ipub-col :span="3">Result:
            <font :class="['ipub-decision-status-item--'+item.decisionStatus]">{{item.decisionStatus?DECISION_STATUS[item.decisionStatus]:'- -'}}</font>
          </ipub-col>
          <ipub-col :span="1.5">
            <font>
              <ipub-tooltip v-if="!['NO_RESPONSE','PENDING_PRE_CHECK','PENDING_FIRST_DECISION','PENDING_FINAL_DECISION'].includes(item.status)">
                <div slot="title">{{item.statusTime ? $moment(item.statusTime).format('HH : mm DD / MM / YYYY'):'--'}}</div>
                <span>
                  Spend: {{(item.invitedTime && item.statusTime) ? $moment(item.statusTime ).diff($moment(item.invitedTime),'days')+1:'--'}} Day(s)</span>
              </ipub-tooltip>
              <span v-else>Spend: -- Day(s)</span>
            </font>
          </ipub-col>
        </ipub-row>
      </div> -->
      <ipub-table :columns="mac?columns['academic']:columns['review']"
                  border
                  :pagination="false"
                  :dataSource="reviewResult">
        <template v-slot:rating="{text}">
          <font>{{text ?rate[text]:''}}</font>
        </template>
        <template v-slot:status="{text}">
          <font v-if="mac">{{ACADEMIC_STATUS[text]}}</font>
          <font v-else>{{REVIEWER_STATUS[text]}}</font>
        </template>
        <template v-slot:decision="{text}">
          <font>{{text?DECISION_STATUS[text]:'- -'}}</font>
        </template>
        <template v-slot:spend="{record}">
          <ipub-tooltip v-if="!['NO_RESPONSE','PENDING_PRE_CHECK','PENDING_FIRST_DECISION','PENDING_FINAL_DECISION'].includes(record.status)">
            <div slot="title">{{record.statusTime ? $moment(record.statusTime).format('HH : mm DD / MM / YYYY'):'--'}}</div>
            <span>
              {{(record.invitedTime && record.statusTime) ? $moment(record.statusTime ).diff($moment(record.invitedTime),'days')+1:'--'}}</span>
          </ipub-tooltip>
          <span v-else>- -</span>
        </template>
      </ipub-table>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import person from '@/api/person'
import macademic from '@/api/macademic'
import { ACADEMIC_STATUS, DECISION_STATUS, REVIEWER_STATUS } from '@/utils/dict'
const review = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Invited Time',
    width: 200,
    dataIndex: 'invitedTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 200,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Decision',
    width: 200,
    dataIndex: 'decisionStatus',
    slot: 'decision'
  },
  {
    title: '',
    enTitle: 'Spend Day(s)',
    width: 150,
    dataIndex: 'spend',
    slot: 'spend'
  },
  {
    title: '',
    enTitle: 'Review Ranking',
    width: 150,
    dataIndex: 'rating',
    slot: 'rating'
  }
]
const academic = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Invited Time',
    width: 200,
    dataIndex: 'invitedTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 200,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Decision',
    width: 200,
    dataIndex: 'decisionStatus',
    slot: 'decision'
  },
  {
    title: '',
    enTitle: 'Spend Day(s)',
    width: 150,
    dataIndex: 'spend',
    slot: 'spend'
  }
]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    mac: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      columns: {
        academic,
        review
      },
      // ACADEMIC_STATUS,
      // REVIEWER_STATUS,
      DECISION_STATUS,
      reviewStatus: REVIEWER_STATUS,
      academicStatus: ACADEMIC_STATUS,
      reviewResult: [],
      params: {
        invitedTimeStart: this.$moment().subtract(60, 'days'),
        invitedTimeEnd: this.$moment()
      },
      timeList: {
        All: 'All',
        day: 'Last 60 Days',
      },
      isActive: 'day',
      dataSource: [],
      rate: {
        EXCELLENT: 'Excellent',
        GOOD: 'Good',
        AVERAGE: 'Average',
        POOR: 'Poor'
      }
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    }),
    REVIEWER_STATUS () {
      let obj = Object.assign({ '': 'All' }, this.reviewStatus)
      return obj
    },
    ACADEMIC_STATUS () {
      let obj = Object.assign({ '': 'All' }, this.academicStatus)
      return obj
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.reviewResult = []
      } else {
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      if (this.mac) {
        this.reviewResult = await macademic.personRecord(this.inputData.personId || this.inputData.id, this.params)
      } else {
        this.reviewResult = await person.rmanuscript(this.inputData.personId || this.inputData.id, this.params)
      }
    },
    searchList (key) {
      this.isActive = key
      if (key === 'day') {
        this.params.invitedTimeStart = this.$moment().subtract(60, 'days')
        this.params.invitedTimeEnd = this.$moment()
      }
      else {
        this.params.invitedTimeStart = null
        this.params.invitedTimeEnd = null
      }
      this.getList()

    },
    cancel () {
      this.params = {}
      this.params.invitedTimeStart = this.$moment().subtract(60, 'days')
      this.params.invitedTimeEnd = this.$moment()
      this.isActive = 'day'
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
